'use client'
import { OverlayContext } from '@/context/OverlayContext'
import { useContext } from 'react'

export const useOverlay = () => {
  const { isActive, setIsActive } = useContext(OverlayContext)

  return { isActive, setIsActive }
}
